import { colors } from "@theme/colors"

const LinkIcon = ({ color = colors.pureWhite, height = 20, width = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.88886 9.05646L5.89199 10.0533C5.3902 10.5551 5.11384 11.2412 5.12369 11.9607C5.13355 12.6802 5.42882 13.3741 5.94454 13.8899C6.46027 14.4056 7.1542 14.7008 7.87369 14.7107C8.59318 14.7206 9.27929 14.4442 9.78108 13.9424L10.7779 12.9455M8.88932 7.05599L9.88619 6.05913C10.1346 5.81067 10.431 5.61494 10.7582 5.48311C11.0855 5.35129 11.4373 5.28595 11.7936 5.29083C12.1498 5.29571 12.5035 5.37071 12.8346 5.51156C13.1656 5.6524 13.4674 5.85632 13.7227 6.11168C13.9781 6.36704 14.182 6.66884 14.3228 6.99985C14.4637 7.33085 14.5387 7.68458 14.5436 8.04083C14.5484 8.39709 14.4831 8.74889 14.3513 9.07616C14.2195 9.40343 14.0237 9.69975 13.7753 9.94821L12.7784 10.9451M7.83359 12.0008L11.8337 8.00073"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LinkIcon
